// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"b8a188e6","771":"ddb5d76c","801":"d35caa02","826":"688b8756","925":"71d6dc20","935":"8bae53cf"}[chunkId] + ".chunk.css";
};